import './App.css';
import "../src/styles/styles.css";


import Home from "./pages/Home";

function App() {
  return (
    <>
      <Home/>
    </>
  );
}

export default App;
